import { apiClient } from './client';
import type { Organization } from '@/types/auth';

export const organizationsApi = {
  list: async (): Promise<Organization[]> => {
    const response = await apiClient.get<Organization[]>('/orgs');
    return response;
  },

  create: async (data: { name: string; description?: string }): Promise<Organization> => {
    const response = await apiClient.post<Organization>('/orgs', data);
    return response;
  },

  update: async (orgId: string, data: { name: string; description?: string }): Promise<Organization> => {
    const response = await apiClient.put<Organization>(`/orgs/${orgId}`, data);
    return response;
  },
};
